export const printOrder = async (order, tenant, apiGet) => {
  let tenantData = tenant || {};
  try {
    const td = await apiGet('/api/tenant');
    if (td) tenantData = td;
  } catch(e) {}

  const items = order.items || [];
  const now = new Date(order.created_at);
  const dataStr = now.toLocaleDateString('pt-BR') + ' ' + now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const payLabels = { dinheiro: 'Dinheiro', cartao: 'Cartão', pix: 'PIX' };

  const rows = items.map(item =>
    '<div class="row"><span>' + item.quantity + 'x ' + item.name + '</span><span>R$ ' + Number(item.item_total).toFixed(2) + '</span></div>' +
    (item.notes ? '<div class="item-notes">* ' + item.notes + '</div>' : '')
  ).join('');

  const html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Comanda #' + order.order_number + '</title>' +
    '<style>' +
    '@page{size:80mm auto;margin:0}' +
    '*{margin:0;padding:0;box-sizing:border-box}' +
    'body{font-family:"Courier New",monospace;font-size:12px;width:80mm;padding:4mm;color:#000}' +
    '.center{text-align:center}' +
    '.bold{font-weight:bold}' +
    '.line{border-top:1px dashed #000;margin:6px 0}' +
    '.row{display:flex;justify-content:space-between;padding:2px 0}' +
    '.items{margin:4px 0}' +
    '.item-notes{font-size:10px;padding-left:16px;color:#333}' +
    'h1{font-size:16px;font-family:"Courier New",monospace}' +
    'h2{font-size:14px;font-family:"Courier New",monospace}' +
    '.footer{font-size:10px;margin-top:8px}' +
    '</style></head><body>' +
    '<div class="center">' +
    '<h1>' + (tenantData.name || 'Restaurante') + '</h1>' +
    (tenantData.phone ? '<div>' + tenantData.phone + '</div>' : '') +
    (tenantData.address ? '<div style="font-size:10px">' + tenantData.address + (tenantData.city ? ' - ' + tenantData.city : '') + '</div>' : '') +
    '</div>' +
    '<div class="line"></div>' +
    '<div class="center bold"><h2>COMANDA #' + order.order_number + '</h2></div>' +
    '<div class="row"><span>' + dataStr + '</span><span>' + (order.order_type === 'delivery' ? 'DELIVERY' : 'RETIRADA') + '</span></div>' +
    '<div class="line"></div>' +
    '<div class="bold">Cliente: ' + order.customer_name + '</div>' +
    (order.customer_phone ? '<div>Tel: ' + order.customer_phone + '</div>' : '') +
    (order.customer_address ? '<div>End: ' + order.customer_address + '</div>' : '') +
    '<div class="line"></div>' +
    '<div class="items">' + rows + '</div>' +
    '<div class="line"></div>' +
    (Number(order.delivery_fee) > 0 ? '<div class="row"><span>Taxa entrega</span><span>R$ ' + Number(order.delivery_fee).toFixed(2) + '</span></div>' : '') +
    '<div class="row bold" style="font-size:14px"><span>TOTAL</span><span>R$ ' + Number(order.total).toFixed(2) + '</span></div>' +
    '<div class="row"><span>Pagamento</span><span>' + (payLabels[order.payment_method] || order.payment_method) + '</span></div>' +
    (order.payment_change_for ? '<div class="row"><span>Troco para</span><span>R$ ' + order.payment_change_for + '</span></div>' : '') +
    '<div class="line"></div>' +
    '<div class="center footer">' +
    '<div>Mise by Neurotech-X</div>' +
    '<div>Obrigado pela preferência!</div>' +
    '</div>' +
    '<script>window.onload=function(){window.print();setTimeout(function(){window.close()},1000);}<\/script>' +
    '</body></html>';

  const printWindow = window.open('', '_blank', 'width=350,height=600');
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
  }
};
